$(document).on('click', '[data-toggle-target]', function (e) {
    var $this = $(this),
        $targets = $($this.attr('data-toggle-target')),
        $wrappers = $($this.attr('data-toggle-wrapper'));

    $wrappers.addClass('hidden');
    $targets.removeClass('hidden');

    ReplaceSimple.init();
});
